import {css, unsafeCSS} from 'lit';
import {accordionOnDarkStyles} from "@/components/accordion/accordion--onDark.styles";
import {sbkCoreBreakpointLg} from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const accordionStyles = css`

  :host {
    display: block;

    --accordion__color--enabled: var(--_accordion__color--enabled, var(--sbkAccordionFgColorOnLightEnabled));
    --accordion__color--hover: var(--_accordion__color--hover, var(--sbkAccordionFgColorOnLightHover));
    --accordion__color--active: var(--_accordion__color--active, var(--sbkAccordionFgColorOnLightActive));
    --accordion__focus: var(--_accordion__focus, var(--sbkAccordionOnLightFocus));
    --accordion__borderRadius--focus: var(--_accordion__borderRadius--focus, var(--sbkAccordionBorderRadiusFocus));
    --accordion__borderGap--focus: var(--_accordion__borderGap--focus, var(--sbkAccordionBorderGapFocus));
    --accordion__border-bottom: var(--_accordion__border-bottom, none);
  }

  :host([alternativestyling]) {
    ${accordionOnDarkStyles}
  }

  .accordion-container {
    border-top: var(--sbkAccordionDivider);
    border-bottom: var(--sbkAccordionDivider);
    padding: var(--sbkAccordionXs) 0;
    max-width: var(--sbkCoreContentAreaBodyMaxWidth);
      margin: -2px 0;
  }

  button {
    outline: 2px solid transparent;
    outline-offset: var(--sbkAccordionBorderGapFocus);
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align:left;
    justify-content: space-between;
    cursor: pointer;
    background: none;
    color : var(--accordion__color--enabled);
    border: none;
    border-radius: var(--sbkAccordionBorderRadiusFocus);
    width: 100%;
    padding: 0;
    margin: 0;
    gap: var(--sbkAccordion3xs);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover {
        color : var(--accordion__color--hover);
    }
  }

  button:active {
    color : var(--accordion__color--active);
  }

  button:focus {
    outline: none;
  }

  button:focus-visible {
    outline: var(--accordion__focus);
  }

  #accordion-panel {
    padding-top: var(--sbkAccordionXs);
    font: var(--sbkAccordionTypographySmallScrBody);
  }

  #accordion-header {
    hyphens: auto;
    font: var(--sbkAccordionTypographySmallScrTitle);
  }

  dd {
    margin-inline-start: 0 ;
  }

  sbk-icon {
    transition: transform 0.1s ease;
  }

  button[aria-expanded="true"] sbk-icon {
    transform: rotate(-180deg);
  }

  @media (min-width: ${breakpointLg}) {
    #accordion-header {
      font: var(--sbkAccordionTypographyLargeScrTitle);
    }
    #accordion-panel{
      font: var(--sbkAccordionTypographyLargeScrBody);
    }
  }
`;